import React from 'react'
import { Link } from 'react-router-dom'
import GallerySection from '../components/GallerySection'
import { imageUrl } from '../lib/images'

export default function CateringPage() {
  const meats = [
    { name: 'Helstegt pattegris', desc: 'Vores mest populære varemærke med sprød svær og specialmarinade.' },
    { name: 'Helstegt oksefilet', desc: 'Mør og saftig oksefilet krydret med havsalt og peber (+10 kr).' },
    { name: 'Porchetta', desc: 'Italiensk krydret rullesteg med urter og sprød svær.' },
    { name: 'Svinekam', desc: 'Klassisk traditionel svinekam tilberedt til perfektion.' },
    { name: 'Vikingekøller', desc: 'Store, møre og saftige køller med masser af kødsmag.' },
    { name: 'Glaseret skinke', desc: 'Mild og mør skinke med let sødlig sennepsglasering.' },
    { name: 'Lammekølle', desc: 'Lammekølle tilberedt med hvidløg og friske urter (+10 kr).' },
    { name: 'Kyllingebryst & Spyd', desc: 'Saftige kyllingestykker og grillede spyd.' },
  ]

  return (
    <div className="py-10 sm:py-16 space-y-16">
      {/* Hero section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#241F1C] tracking-tight leading-tight">
              Catering med smagfuld mad til enhver fest
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-[#6E635C] leading-relaxed">
              Vi leverer maden – så du kan nyde dagen! Planlægger du et arrangement, og ønsker du at servere
              frisk mad fra grillen uden stress og besvær? Hos Overgaard Pattegrise tilbyder vi velsmagende grill catering,
              der passer perfekt til alt fra firmafester og bryllupper til fødselsdage og sommerfester.
            </p>

            <div className="pt-2 flex flex-wrap gap-3 sm:gap-4">
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
                <span>Sammensæt cateringmenu</span>
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 bg-transparent text-[#241F1C] border border-[#241F1C]/40 px-5 py-2.5 sm:px-6 sm:py-3.5 font-bold text-xs sm:text-sm transition-colors hover:bg-[#241F1C] hover:text-white"
              >
                <span>Få uforpligtende tilbud</span>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden aspect-[4/3]">
              <img
                src={imageUrl('/_assets/img-4533.jpeg', 'width=800,quality=80,format=auto')}
                alt="Overgaard Pattegrise grillmestre ved buffeten"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE OVERGAARD CATERING */}
      <section className="bg-white pt-16 pb-8 sm:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 border-t border-[#E6DFD5]/60 pt-16">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
              Hvorfor vælge Overgaard Pattegrise catering?
            </h2>
            <p className="mt-2 text-xs sm:text-sm text-[#6E635C]">
              Vores catering er fleksibel, stemningsfuld og lavet fra bunden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 shadow-md space-y-3 transition-shadow duration-300 hover:shadow-xl">
              <i className="fa-solid fa-carrot text-[#C25E27] text-2xl" aria-hidden="true" />
              <h3 className="font-bold text-lg text-[#241F1C]">Friske råvarer &amp; god smag</h3>
              <p className="text-sm text-[#6E635C] leading-relaxed">
                Maden tilberedes frisk med respekt for råvarerne. Vi udvælger det bedste kød og tilbehør,
                så hver bid smager fantastisk.
              </p>
            </div>

            <div className="bg-white p-8 shadow-md space-y-3 transition-shadow duration-300 hover:shadow-xl">
              <i className="fa-solid fa-sliders text-[#C25E27] text-2xl" aria-hidden="true" />
              <h3 className="font-bold text-lg text-[#241F1C]">Skræddersyede menuer</h3>
              <p className="text-sm text-[#6E635C] leading-relaxed">
                Uanset om du vil have en helstegt pattegris eller en stegebuffet med flere slags kød,
                kartofler og salater, tilpasser vi menuen til dine gæster.
              </p>
            </div>

            <div className="bg-white p-8 shadow-md space-y-3 transition-shadow duration-300 hover:shadow-xl">
              <i className="fa-solid fa-truck text-[#C25E27] text-2xl" aria-hidden="true" />
              <h3 className="font-bold text-lg text-[#241F1C]">Levering direkte på adressen</h3>
              <p className="text-sm text-[#6E635C] leading-relaxed">
                Vi ankommer til aftalt tid og hjælper med udskæring og anretning, så du roligt kan nyde
                dit arrangement sammen med dine gæster.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* POPULAR CATERING MEATS GRID */}
      <section className="bg-white pt-0 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 border-t border-[#E6DFD5] pt-16">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
              Vores kødudvalg til din buffet
            </h2>
            <p className="text-xs sm:text-sm text-[#6E635C] mt-2">
              Vælg mellem et stort udvalg af møre stege, krydret fjerkræ og saftige specialiteter.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {meats.map((m, idx) => (
              <div key={idx} className="bg-white p-6 shadow-md transition-shadow duration-300 hover:shadow-xl space-y-2">
                <h3 className="font-bold text-base text-[#241F1C] flex items-center gap-2">
                  <i className="fa-solid fa-drumstick-bite text-[#C25E27] text-sm" aria-hidden="true" />
                  <span>{m.name}</span>
                </h3>
                <p className="text-xs text-[#6E635C] leading-relaxed">{m.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/bestil"
              className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 sm:px-8 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
            >
              <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
              <span>Sammensæt dine kødvalg i guiden</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection
        gallerySlug="catering-buffet-galleri"
        title="Billeder af vores catering &amp; buffeter"
        subtitle="Se eksempler på vores anretninger, fade og buffetborde."
      />
    </div>
  )
}
